import styles from './index.module.scss';
import { Row, Col } from 'antd';
import {
  IoBookOutline,
  IoGlobeOutline,
  IoLibraryOutline,
} from 'react-icons/io5';
import { Link, useLocation } from 'react-router-dom';
import cs from 'classnames';

const MobileMenu = () => {
  const { pathname, hash } = useLocation();

  return (
    <div className={styles['menu']}>
      <Row>
        <Col xs={8}>
          <Link
            to="/dashboard/TadatoonLibrary"
            className={cs([
              styles['icons'],
              `${pathname}${hash}` === '/dashboard/TadatoonLibrary'
                ? styles['active']
                : '',
            ])}>
            <IoGlobeOutline size={24} />
            <span>Tadatoon library</span>
          </Link>
        </Col>
        <Col xs={8}>
          <Link
            to="/dashboard/library"
            className={cs([
              styles['icons'],
              `${pathname}${hash}` === '/dashboard/library'
                ? styles['active']
                : '',
            ])}>
            <IoLibraryOutline size={24} />
            <span>My library</span>
          </Link>
        </Col>
        <Col xs={8}>
          <Link to="/story" className={styles['icons']}>
            <IoBookOutline size={24} />
            <span>Create Story</span>
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default MobileMenu;
